import { useHistory } from 'react-router-dom'
import { NavigationAction } from './navigationAction/navigationAction.types'
import { OverlayAction } from '../actions/overlayAction/overlayAction.types'
import { TrackAction } from './trackAction/trackAction.types'

export interface ActionExecutor {
  execute(action: Action<ActionType>, context: ActionContext): void
}

export enum ActionType {
  Navigation = 'NAVIGATION',
  Track = 'TRACK',
  Overlay = 'OVERLAY'
}

export type Action<T extends ActionType> =
  | (T extends ActionType.Navigation ? NavigationAction : never)
  | (T extends ActionType.Track ? TrackAction : never)
  | (T extends ActionType.Overlay ? OverlayAction : never)

export type ActionContext = {
  history: ReturnType<typeof useHistory>
  showOverlay: (data: OverlayAction) => void
}
